export default __webpack_public_path__ + "static/generalEnglishCard-64608d8c6d423ec2c2135ec3434bc651.png";